import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Textarea } from '../../../../../../../../CommonComponents/OPL/Textarea/Textarea';

export const Comments = () => {
  const { register } = useFormContext();

  return (
    <Textarea
      {...register('bankAccount.Comments')}
      label="Comments"
      placeholder="Add additional information such as riders"
      rows={5}
    />
  );
};
